/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import { useEffect, useState, Fragment } from "react";

import axios from "axios";

import { useStoreon } from "storeon/react";
import LazyLoad from "react-lazyload";

import { forceCheck } from "react-lazyload";
import PerfectScrollbar from "react-perfect-scrollbar";

import { throttle } from "lodash";

import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";

import SerachIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import Button from "@material-ui/core/Button";

import t from "translations";

const AddTextButton = styled(Button)`
  margin-bottom: 10px;
  width: 100%;
`;

const FontsListWrap = styled.ul`
  margin: 0px;
  padding: 0px;
  list-style: none;
  > li {
    padding: 5px;
    cursor: pointer;
    color: #eee;
    margin: 0px;
    position: relative;
    border-bottom: 1px solid #595959;
    :hover {
      background: #444;
    }
    &.active {
      background: #555;
    }
    img {
      max-height: 45px;
    }
  }
`;
//FIXME: Gallery FontList  search bar dublicate code;
const SearchBar = styled(TextField)`
  margin-bottom: 8px;
  .clear {
    color: #9d9d9d;
    font-size: 18px;
    cursor: pointer;
    display: ${props => (props.value.length ? "block" : "none")};
  }
  > div {
    fieldset {
      border-width: 1px;
      border-color: white;
      border-radius: 5px;
      background: white;
    }
    :hover {
      fieldset {
        border-color: #a8bb43 !important;
      }
    }
    input {
      z-index: 1;
      color: black;
      padding: 9px 14px;
      padding-top: 6px;
      padding-left: 0px;
      font-size: 19px;
    }
  }

  .focused fieldset {
    border-width: 2px !important;
    border-color: #a8bb43 !important;
  }
  > div > div {
    z-index: 1;
    > svg {
      color: #9d9d9d;
      width: 1.5em;
      height: 1.5em;
      z-index: 1;
    }
  }
  @media screen and (max-width: 480px) {
    > div {
      input {
        z-index: 1;
        color: black;
        padding: 5px 14px;
        padding-top: 5px;
        padding-left: 0px;
        font-size: 16px;
      }
    }
    > div > div {
      z-index: 1;
      color: #9d9d9d;
      > svg {
        width: 1em;
        height: 1em;
        z-index: 1;
      }
    }
  }
`;

const Font = props => {
  const { onClick, font } = props;
  const { family, preview } = font;
  return (
    <li
      onClick={_ => {
        onClick(font);
      }}
    >
      <LazyLoad height={30} offset={150}>
        <img src={preview} alt={family} />
      </LazyLoad>
    </li>
  );
};
//FIXME: exclude them on backend
const excludedFonts = [
  "Angkor",
  "Battambang",
  "Bayon",
  "Bokor",
  "Chenla",
  "Content",
  "Dangrek",
  "Freehand",
  "Kantumruy",
  "Khmer",
  "Kantumruy",
  "Kdam Thmor",
  "Khmer",
  "Koulen",
  "Metal",
  "Moul",
  "Moulpali",
  "Nokora",
  "Odor Mean Chey",
  "Preahvihear",
  "Siemreap",
  "Suwannaphum",
  "Taprom",
  "Fasthand"
];

let allFonts = [];
let count = 45;

const loadFont = (family, activeObject, canvas, dispatch) => {
  const font = allFonts.find(font => font.family === family);
  if (!font) {
    console.error(`Unknown font family: ${family}`);
    return;
  }
  const fontObj = new FontFace(font.family, `url(${font.files.regular})`);
  fontObj
    .load()
    .then(loadedFont => {
      document.fonts.add(loadedFont);
      if (activeObject) {
        activeObject.set({
          fontFamily: font.family,
          fontWeight: 400,
          fontStyle: "normal"
        });
        activeObject.fontData = font;
        dispatch("activeObject/updateFont", activeObject);
      } else {
        window.fabric.util.clearFabricFontCache();
        canvas
          .getObjects()
          .filter(o => o.type === "i-text")
          .forEach(fontObj => {
            fontObj.dirty = true;
          });
        canvas
          .getObjects()
          .filter(o => o.type === "i-text")
          .forEach(text => text.set({ fontFamily: text.fontFamily }));
      }
      canvas.requestRenderAll();
    })
    .catch(function(error) {
      console.error(`Font ${family} loading failed`, error);
    });
};

const loadCanvasFonts = (activeCanvas, dispatch) => {
  if (!allFonts) {
    return;
  }
  const canvasFonts = activeCanvas
    .getObjects()
    .filter(o => o.type === "i-text")
    .map(text => text.fontFamily);
  const fontsToLoad = [...new Set(canvasFonts)];
  fontsToLoad.forEach(family => {
    loadFont(family, undefined, activeCanvas, dispatch);
  });
};

const FontsList = () => {
  let scrollRef;
  const { dispatch, activeMenu, canvas, activeObject } = useStoreon(
    "activeMenu",
    "canvas",
    "activeObject"
  );
  const [fonts, setFonts] = useState([]);

  const [search, setSearch] = useState("");

  useEffect(
    _ => {
      forceCheck();
    },
    [activeMenu, fonts]
  );

  useEffect(
    _ => {
      if (!activeObject.type && activeMenu === 99) {
        // dispatch("menu/close");
      }
    },
    [activeObject, activeMenu, dispatch]
  );

  useEffect(
    _ => {
      if (!canvas || !allFonts.length) {
        return;
      }
      loadCanvasFonts(canvas, dispatch);
    },
    [canvas, dispatch]
  );

  useEffect(() => {
    canvas &&
      canvas.on("canvas:loaded", e => {
        if (canvas) {
          loadCanvasFonts(canvas, dispatch);
        }
      });
  }, [canvas, dispatch]);

  useEffect(_ => {
    axios
      .get("/wp-json/dpe/v1/fonts")
      .then(resp => {
        if (resp.data.length > 0) {
          allFonts = resp.data;
          allFonts = allFonts.filter(font => {
            if (font.files.regular && !excludedFonts.includes(font.family)) {
              return true;
            }
            return false;
          });
          setFonts(allFonts.slice(0, count));
        }
      })
      .catch(err => {
        console.error("Fonts list error", err);
      });
  }, []);

  const handleSearch = e => {
    const searchTerm = e.target.value;
    const fontsFound = allFonts
      .filter(
        font =>
          font.family.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      )
      .slice(0, 60);
    scrollRef._container.scrollTop = 0;
    setFonts(fontsFound);
    setSearch(searchTerm);
  };

  const handleFontClick = font => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      loadFont(font.family, activeObject, canvas, dispatch);
    }
  };

  const checkLazyLoad = throttle(forceCheck, 200);
  return (
    <Fragment>
      <AddTextButton
        variant="contained"
        color="secondary"
        onClick={() => {
          dispatch("canvas/text/add");
        }}
      >
        <TextFieldsIcon />
        {t.clickToAddText}
      </AddTextButton>
      {activeObject.type === "i-text" && (
        <Fragment>
          <SearchBar
            value={search}
            variant="outlined"
            fullWidth
            placeholder="Font name search"
            onChange={handleSearch}
            onKeyPress={ev => {
              if (ev.key === "Enter") {
                // getImages(category, 1, type);
                ev.preventDefault();
              }
            }}
            InputProps={{
              classes: {
                focused: "focused"
              },
              startAdornment: (
                <InputAdornment position="start">
                  <SerachIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <div
                    className="clear"
                    onClick={() => {
                      setSearch("");
                      count = 45;
                      setFonts(allFonts.slice(0, count));
                      scrollRef._container.scrollTop = 0;
                    }}
                  >
                    <CloseIcon />
                  </div>
                </InputAdornment>
              )
            }}
          />

          <PerfectScrollbar
            ref={ref => {
              scrollRef = ref;
            }}
            onScrollY={checkLazyLoad}
            onYReachEnd={() => {
              if (!scrollRef) return;
              if (search.length) return;
              count += 30;
              setFonts(allFonts.slice(0, count));
            }}
          >
            <FontsListWrap>
              {fonts.map(font => (
                <Font font={font} key={font.family} onClick={handleFontClick} />
              ))}
            </FontsListWrap>
          </PerfectScrollbar>
        </Fragment>
      )}
    </Fragment>
  );
};

export default FontsList;
